import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionListDialogComponent, ActionListDialogData } from './action-list-dialog.component';

import { Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { ActionsApiService } from './actions.api.service';

@Component({
  template: `
    <h2 mat-dialog-title>
      {{ 'ACTION_LISTS.EXPORT_ACCOUNT_DATA_DIALOG.TITLE' | translate: { name: actionList.name } }}
    </h2>
    <mat-dialog-content>
      <p>
        {{ 'ACTION_LISTS.EXPORT_ACCOUNT_DATA_DIALOG.EXPORT_TAKES_SEVERAL_MINUTES' | translate }}
      </p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-raised-button color="primary" (click)="exportAccountData()">
        <ng-container *ngIf="!buttonLoading; else matSpinner">
          {{ 'ACTION_LISTS.EXPORT_ACCOUNT_DATA_DIALOG.EXPORT' | translate }}
        </ng-container>
        <ng-template #matSpinner>
          <mat-spinner [diameter]="30"></mat-spinner>
        </ng-template>
      </button>
      <button mat-button matDialogClose tabindex="-1" class="close-button">
        {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./action-list-dialog.component.scss', './action-list-actions.component.scss'],
  standalone: false,
})
export class ExportAccountDataDialogComponent extends ActionListDialogComponent {
  buttonLoading = false;

  constructor(
    public dialogRef: MatDialogRef<ExportAccountDataDialogComponent>,
    public router: Router,
    private actionsService: ActionsApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: ActionListDialogData,
    private snackbarService: SnackbarService,
  ) {
    super(dialogRef, router);
  }

  exportAccountData(): void {
    if (this.buttonLoading) {
      return;
    }

    this.buttonLoading = true;

    let response$: Observable<any>;
    if (this.data && this.data.useBulkActionsMicroservice) {
      response$ = this.actionsService.exportAccountNAPData(this.actionList.id);
    } else {
      response$ = this.actionsService.exportAccountData(this.actionList.id);
    }

    response$.subscribe(
      () => this.handleSuccess(),
      () => this.handleError(),
    );
  }

  private handleSuccess(): void {
    this.snackbarService.successSnack(`Account data export for ${this.actionList.name} started.`);
    this.dialogRef.close(true);
    this.buttonLoading = false;
  }

  private handleError(): void {
    this.snackbarService.errorSnack(`Failed to export account data for ${this.actionList.name}. Please try again.`);
    this.buttonLoading = false;
  }
}
